import AbstractObserver from './abstract';

export default class HeaderHideSectionObserver extends AbstractObserver {
  constructor(element) {
    super(element);
    this.dataSettings = this.element.hasAttribute('data-ua-header-options')
      ? JSON.parse(this.element.getAttribute('data-ua-header-options'))
      : {};
  }

  init() {
    this.offset = isFinite(this.dataSettings.fixMoment) ? this.dataSettings.fixMoment : 5;
    this.section = this.element.querySelector('.navbar-section-hidden');
    this.defaultState = true;

    this.sectionHeight = this.section ? this.section.offsetHeight : 0;

    return this;
  }

  destroy() {
    if (this.section) {
      this.setMarginTop(0);
    }

    return this;
  }

  check() {
    if (!this.section) {
      return this;
    }

    const docScrolled = window.scrollY;

    if (docScrolled > this.offset && this.defaultState) {
      this.changeState();
    } else if (docScrolled <= this.offset && !this.defaultState) {
      this.toDefaultState();
    }

    return this;
  }

  changeState() {
    this.setMarginTop(this.sectionHeight * -1 - 1);
    this.defaultState = !this.defaultState;

    return this;
  }

  toDefaultState() {
    this.setMarginTop(0);
    this.defaultState = !this.defaultState;

    return this;
  }

  setMarginTop(value) {
    this.element.transition = 'margin-top .5s';
    this.element.style.marginTop = value + 'px';
  }
}
